module.exports = __webpack_public_path__ + "static/media/offer-deal-bg.6cd0283d.jpg";